import { render, staticRenderFns } from "./statTransfYear.vue?vue&type=template&id=7dcfc9f7&scoped=true&"
import script from "./statTransfYear.vue?vue&type=script&lang=js&"
export * from "./statTransfYear.vue?vue&type=script&lang=js&"
import style0 from "./statTransfYear.vue?vue&type=style&index=0&id=7dcfc9f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcfc9f7",
  null
  
)

export default component.exports